<template>
    <div class="pageInfo">
        <el-form :inline="true" :model="form" ref="formData" v-loading="loading"
                 label-width="120px">
            <el-form-item label="所属部门">
                <el-input style="width:200px" v-model="form.departmentNameBill" readonly></el-input>
            </el-form-item>
            <el-form-item label="处理单号">
                <el-input style="width:200px" v-model="form.billNo" readonly></el-input>
            </el-form-item>
            <el-form-item label="处理日期">
                <el-input style="width:200px" v-model="form.billDate" readonly></el-input>
            </el-form-item>

            <el-form-item label="项目名称">
                <el-input style="width:200px" v-model="form.projectName" readonly></el-input>
            </el-form-item>
            <el-form-item label="运维申请单号">
                <el-input style="width:200px" v-model="form.relaBillNo" readonly></el-input>
            </el-form-item>
            <el-form-item label="申请日期">
                <el-input style="width:200px" v-model="form.relaBillDate" readonly></el-input>
            </el-form-item>

            <el-form-item label="申请人">
                <el-input style="width:200px" v-model="form.applyBy" readonly></el-input>
            </el-form-item>
            <el-form-item label="申请部门">
                <el-input style="width:200px" v-model="form.departmentName" readonly></el-input>
            </el-form-item>
            <el-form-item label="服务类型">
                <el-input style="width:200px" v-model="form.serviceType" ></el-input>
            </el-form-item>

            <el-form-item label="紧急程度">
                <el-input style="width:200px" v-model="form.urgencyType" ></el-input>
            </el-form-item>
            <el-form-item label="客户">
                <el-input style="width:200px" v-model="form.customerName" ></el-input>
            </el-form-item>
            <el-form-item label="服务地点">
                <el-input style="width:200px" v-model="form.serviceAddress" ></el-input>
            </el-form-item>

            <el-form-item label="处理负责人" >
                <el-input style="width:200px" v-model="form.handleBy" ></el-input>
            </el-form-item>
            <el-form-item label="处理部门" >
                <el-input style="width:200px" v-model="form.departmentNameHandle" ></el-input>
            </el-form-item>
            <el-form-item label="处理进度" >
                <el-input style="width:200px" v-model="form.handleProgress" ></el-input>
            </el-form-item>


            <el-form-item label="预计完成日期" >
                <el-input style="width:200px" v-model="form.dispatchBy" ></el-input>
            </el-form-item>
            <el-form-item label="工时合计" >
                <el-input style="width:200px" v-model="form.workingTotal" ></el-input>
            </el-form-item>
            <el-form-item label="配件合计" >
                <el-input style="width:200px" v-model="form.accessoryTotal" ></el-input>
            </el-form-item>

            <el-form-item label="运维费用合计" >
                <el-input style="width:200px" v-model="form.feeTotal" ></el-input>
            </el-form-item>

            <el-form-item label="备注">
                <el-input style="width:860px"
                        type="textarea"
                        v-model="form.remark"
                        rows="2">
                </el-input>
            </el-form-item>
        </el-form>


        <el-tabs style="padding: 0 20px" v-model="activeName">
            <el-tab-pane name="first">
                <span slot="label"><i class="el-icon-date"></i>运维配件信息</span>
                <div  style="padding-top: 20px">
                    <el-table
                            ref="table"
                            :data="dataList_Accessory"
                            height="400"
                            style="width: 100%;"
                            highlight-current-row
                            row-key="id"
                            :header-cell-style="headerStyle"
                            :cell-style="cellStyle"
                            border>
                        <el-table-column
                                type="index"
                                label="序号"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                prop="typeName"
                                width="100"
                                label="物资类别">
                        </el-table-column>
                        <el-table-column
                                prop="proCode"
                                width="120"
                                label="物资编码">
                        </el-table-column>
                        <el-table-column
                                prop="proName"
                                width="200"
                                label="物资名称">
                        </el-table-column>
                        <el-table-column
                                prop="units"
                                width="100"
                                label="计量单位">
                        </el-table-column>
                        <el-table-column
                                prop="icon"
                                width="100"
                                label="规格型号">
                        </el-table-column>
                        <el-table-column
                                prop="origin"
                                width="100"
                                label="产地">
                        </el-table-column>
                        <el-table-column
                                prop="color"
                                width="100"
                                label="颜色">
                        </el-table-column>
                        <el-table-column
                                prop="num"
                                width="100"
                                label="数量">
                        </el-table-column>
                        <el-table-column
                                prop="taxPrice"
                                width="100"
                                label="单价">
                        </el-table-column>
                        <el-table-column
                                prop="taxTotal"
                                width="100"
                                label="金额">
                        </el-table-column>
                        <el-table-column
                                prop="remark"
                                label="备注">
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>

            <el-tab-pane name="second">
                <span slot="label"><i class="el-icon-date"></i>运维产品信息</span>
                <div style="padding-top: 20px">
                    <el-table
                            ref="table"
                            :data="dataList_Product"
                            height="400"
                            style="width: 100%;"
                            highlight-current-row
                            row-key="id"
                            :header-cell-style="headerStyle"
                            :cell-style="cellStyle"
                            border>
                        <el-table-column
                                type="index"
                                label="序号"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                prop="typeName"
                                width="100"
                                label="设备类别">
                        </el-table-column>
                        <el-table-column
                                prop="proCode"
                                width="120"
                                label="设备编码">
                        </el-table-column>
                        <el-table-column
                                prop="proName"
                                width="150"
                                label="设备名称">
                        </el-table-column>
                        <el-table-column
                                prop="units"
                                width="100"
                                label="计量单位">
                        </el-table-column>
                        <el-table-column
                                prop="icon"
                                width="100"
                                label="规格型号">
                        </el-table-column>
                        <el-table-column
                                prop="origin"
                                width="100"
                                label="产地">
                        </el-table-column>
                        <el-table-column
                                prop="color"
                                width="100"
                                label="颜色">
                        </el-table-column>
                        <el-table-column
                                prop="num"
                                width="100"
                                label="应运维数量">
                        </el-table-column>
                        <el-table-column
                                prop="handledNum"
                                width="100"
                                label="已运维数量">
                        </el-table-column>
                        <el-table-column
                                prop="handleFee"
                                width="120"
                                label="运维费用">
                        </el-table-column>
                        <el-table-column
                                prop="handleHours"
                                width="120"
                                label="运维时长">
                        </el-table-column>
                        <el-table-column
                                prop="handleDetails"
                                width="150"
                                label="运维详情">
                        </el-table-column>
                        <el-table-column
                                prop="remark"
                                label="备注">
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>

            <el-tab-pane name="third">
                <span slot="label"><i class="el-icon-date"></i>派工人员信息</span>
                <div style="padding-top: 20px">
                    <el-table
                            ref="table"
                            :data="dataList_Person"
                            height="400"
                            style="width: 100%;"
                            highlight-current-row
                            row-key="id"
                            :header-cell-style="headerStyle"
                            :cell-style="cellStyle"
                            border>
                        <el-table-column
                                type="index"
                                label="序号"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                prop="staffName"
                                width="100"
                                label="姓名">
                        </el-table-column>
                        <el-table-column
                                prop="departmentName"
                                width="150"
                                label="部门">
                        </el-table-column>
                        <el-table-column
                                prop="workingNum"
                                width="150"
                                label="工时">
                        </el-table-column>
                        <el-table-column
                                prop="workingPrice"
                                width="100"
                                label="工时单价">
                        </el-table-column>
                        <el-table-column
                                prop="workingTotal"
                                width="100"
                                label="工时合计">
                        </el-table-column>
                        <el-table-column
                                prop="remark"
                                width="100"
                                label="备注">
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
        </el-tabs>

    </div>
</template>

<script>
    export default {
        name: "InfoPage",
        props: ['formData', 'loading'],
        components: {},
        data() {
            return {
                dialoading: this.loading,
                form: JSON.parse(JSON.stringify(this.formData)),
                dialogVisible: true,
                formLabelWidth: '80px',

                activeName: "first",
                dataList_Accessory:[],
                dataList_Person:[],
                dataList_Product:[],
                pageInfo_Accessory: {
                    page: 1,
                    pagesize: 200,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                },
                pageInfo_Person: {
                    page: 1,
                    pagesize: 200,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                },
                pageInfo_Product: {
                    page: 1,
                    pagesize: 200,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                },
            };
        },
        mounted() {
            this.getListData_Accessory();
            this.getListData_Person();
            this.getListData_Product();
        },
        methods: {
            async getListData_Accessory() {
                this.dialoading = true;
                let param = {
                    url: "/handling/listAccessory",
                    param: {
                        billId:this.form.billId,
                        limit: this.pageInfo_Accessory.pagesize,
                        page: this.pageInfo_Accessory.page
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    this.dataList_Accessory = data.data.data;
                    this.pageInfo_Accessory.total = data.data.count;
                }
                this.dataList_Accessory.map(item=>{
                    item._edit = true
                })
                this.dialoading = false;
            },

            async getListData_Person() {
                this.dialoading = true;
                let param = {
                    url: "/handling/listPerson",
                    param: {
                        billId:this.form.billId,
                        limit: this.pageInfo_Person.pagesize,
                        page: this.pageInfo_Person.page
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    this.dataList_Person = data.data.data;
                    this.pageInfo_Person.total = data.data.count;
                }
                this.dataList_Person.map(item=>{
                    item._edit = true
                })
                this.dialoading = false;
            },

            async getListData_Product() {
                this.dialoading = true;
                let param = {
                    url: "/handling/listProduct",
                    param: {
                        billId:this.form.billId,
                        limit: this.pageInfo_Product.pagesize,
                        page: this.pageInfo_Product.page
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    this.dataList_Product = data.data.data;
                    this.pageInfo_Product.total = data.data.count;
                }
                this.dataList_Product.map(item=>{
                    item._edit = true
                })
                this.dialoading = false;
            },

            headerStyle() {
                return "text-align:center;height:35px;line-height:35px;padding: 5px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle() {
                return "text-align:center"
            },
        }
    }
</script>

